export default __webpack_public_path__ + "static/media/submit-feedback-new.ec14f1e4.svg";